import React, { useState, useEffect } from 'react';
import {
  Container,
  TextField,
  Button,
  Box,
  Modal,
  Paper,
  Tooltip,
  Typography
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';

const EditStatus = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [StatusName, setStatusName] = useState('');
  const { StatusId } = useParams();
  const navigate = useNavigate();

  // Static Status data
  const staticStatusData = [
      { StatusId: 1, StatusName: 'Visit Schedule' },
    { StatusId: 2, StatusName: 'Need Time' },
    { StatusId: 3, StatusName: 'Lost Lead' },
    { StatusId: 4, StatusName: 'Needs Discount' },
    { StatusId: 5, StatusName: 'See Remarks column' },
    { StatusId: 6, StatusName: 'Will Register' },
    { StatusId: 7, StatusName: 'To Follow Up' },
    { StatusId: 8, StatusName: 'Will Enroll Next Month' },
  ];

  useEffect(() => {
    // Find the Status to edit based on StatusId
    const Status = staticStatusData.find(
      Status => Status.StatusId === parseInt(StatusId)
    );
    if (Status) {
      setStatusName(Status.StatusName);
    } else {
      alert('Status not found');
    }
  }, [StatusId]);

  const handleUpdate = () => {
    if (StatusName) {
      console.log('Updated Status:', StatusName);
      setShowSuccessModal(true);
    } else {
      alert('Please enter a Status');
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <Container mt={4}>
      <Box
        sx={{
          backgroundColor: 'rgba(2, 78, 101, 1)',
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '2px auto',
          width: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Edit Status
        </Typography>
      </Box>

      <Paper elevation={3} style={{ 
        padding: 16, 
        width: '100%', 
        margin: 'auto', 
        marginTop: 6, 
        backgroundColor: '#f8fdfeff' 
      }}>
        <div>
          <TextField
            label="Status"
            variant="outlined"
            fullWidth
            value={StatusName}
            onChange={(e) => setStatusName(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={!StatusName && "Enter Status"} arrow>
            <span>
              <Button
                variant="contained"
                onClick={handleUpdate}
                sx={{ 
                  mr: 2,
                  backgroundColor: '#127498ff',
                  '&:hover': { backgroundColor: '#116280ff' }
                }}
                disabled={!StatusName}
              >
                UPDATE
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            CANCEL
          </Button>
        </div>
      </Paper>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Status Updated ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Status Updated Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default EditStatus;